(function () {
    if (window.adobeDataLayer) {
        const checkOutBtn = document.querySelector('.accessDenial-btn-checkout a');

        checkOutBtn?.addEventListener('click', e => {
            e.preventDefault();
            const hrefValue = e.currentTarget.getAttribute('href'),
                offers = document.querySelectorAll('[name = "purchaseAccessRadio"]'),
                offer = UX.utils.convertToArray(offers).filter(radio => radio.checked)[0],
                offerDescription = offer?.parentElement?.querySelector('.title')?.textContent,
                offerPrice = offer?.parentElement?.querySelector('.price')?.textContent,
                itemData = window.adobeDataLayer.getState()?.content?.item;

            const product = {
                'item-doi': itemData?.doi,
                'item-name': itemData?.title,
                'item-type': itemData?.type,
                'offer-code': offer?.getAttribute('itemid'),
                'offer-description': offerDescription?.replace(/\s+/g, ' ').trim(),
                units: 1,
                price: offerPrice,
            };
            UX.adobeDigitalData.eCommerce.AddToCart([product]);
            hrefValue && (window.location.href = hrefValue);
        });
    }

    const accessDenial = {
        $slotLicense: $('.slotLicenseConsumption'),
        $loginTab: $('.accessDenial--tab .login-options'),
        isSlide: false,

        init: function () {
            $('.accessDenial--tab .accordion-tabbed__tab.js--open > a').click();
            accessDenial.control();
        },
        control: function () {
            window.addEventListener('load', () => {
                const checkedInput = document.querySelector('.accessDenialRight .radio--primary input:checked'),
                    checkedInputData = checkedInput?.getAttribute('data-key'),
                    accessDenialBtn = document.querySelector('.accessDenialRight .accessDenial-btn a');

                if (checkedInputData !== accessDenialBtn?.getAttribute('data-key')) {
                    accessDenialBtn.setAttribute('data-key', checkedInputData);
                    accessDenialBtn.setAttribute('href', `/action/addToCart?id=${checkedInputData}`);
                }
            });

            accessDenial.$slotLicense.on('click', '.linkBtn', function (e) {
                e.preventDefault();
                if (!accessDenial.$loginTab.hasClass('js--open')) {
                    accessDenial.$loginTab.find('> a').click();
                }
            });

            $('.purchase-options-container .add-journal-to-cart')
                .last()
                .find('input.purchase-access-option')
                .attr('checked', 'checked');
        },
    };

    UX.accessDenial = accessDenial;
})();
